const input = {
    username: 'Tên người dùng',
    password: 'Mật khẩu',
    email: 'Email',
    phone_number: 'Số điện thoại',
    confirm_password: 'Xác nhận mật khẩu',
    search_region_code: 'Mã khu vực tìm kiếm',
    backup_code: 'Mã dự phòng',
};
export default Object.freeze(input);
